/*
 * File: form-string.ts
 * File Created: 2024-01-11 01:28:50
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-26 01:31:47
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import {
    IFormComponentAttr,
    IFormValidateResult,
    createRequiredValidator,
} from "../../core/lib/core";
import { PropInnateSync } from "@root/core/vue-props";
import {
    StringInputType,
    typeProp,
} from "@root/components/inputs/input-string/core/input-type-prop";
import { UITag } from "@root/core/tags";
import { makeRequiredValidator } from "@root/core/decorators/make-validator";

@Component
@UITag.setDefault({
    uiBlockAutofill: true,
})
export default class FormString extends BaseFormComponent {
    @PropInnateSync("value", { type: String, required: false })
    innateValue!: string | undefined;

    /// private helpers
    // required validation for string
    @makeRequiredValidator({
        validator: (o) => !(o.value === "" || o.value == null),
    })
    defaultRequired() {
        return undefined;
    }
}
